define('controllers/vacations',['require','johngrid','ractivejs','layout','services/bookingService','utils','rv!templates/vacationdetails','rv!templates/partials/hotelRating','rv!templates/partials/star','rv!templates/partials/halfStar'],function (require) {
    var CreateJohnGrid = require('johngrid');
    var Ractive = require('ractivejs');
    var layout = require('layout');
    var bookingService = require('services/bookingService');
    var utils = require('utils');
    var vacationsController = {
        load: function (qs) {
            function init() {
                /*Tabs*/
                var loadedPlan = false;
                $('#vac_tabs a').on('click', function(e) {
                    var $this = $(this);
                    var isPaymentPlan = $this.attr('href') === '#paymentPlan';
                    $this.tab('show');
                    if (isPaymentPlan && !loadedPlan) {
                        loadPlan();
                    }
                });

                /*Payment Plan*/
                $('#refreshPlan').on('click', loadPlan);

                function loadPlan() {
                    vacationsController.bookController = window.app.controllerManager.controllers.book[0]; //todo: separate the tabs into different views, run through the hash change pipeline
                    vacationsController.bookController.load();
                    layout.loadServerData();
                    loadedPlan = true;
                }



                /*Vacation Grid*/
                vacationsController.grid = CreateJohnGrid();
                var grid = vacationsController.grid,
                    columns = [
                        { DataField: "Name" },
                        { DataField: "HotelName", HeaderText: "Hotel" },
                        { DataField: "CheckIn", HeaderText: "Check In" },
                        { DataField: "CheckOut", HeaderText: "Check Out" },
                        { DataField: "Status" },
                        { DataField: "Canceled" }
                    ],
                    ajaxURL = "/myaccount/vacations/vacationajax.aspx";

                grid.UIComponents.BackButtonText = "Return to Vacations";
                grid.selectHelpers.init($("#viewVacation"));
                grid.selectHelpers.onSelect = function (item) {
                    console.log(item);
                    item.tpDiffs = null;
                    bookingService.getBookingLogs('fe // Vacations.js - grid.selectHelpers.onSelect // item', JSON.stringify(item));
                    vacationsController.ractive = new Ractive({
                        el: '#vacationdetails',
                        template: require('rv!templates/vacationdetails'),
                        data: {
                            data: item,
                            loadingTpDiffs: false,
                            tpDiffs: [],
                            isDba: window.ServerData.user.isDba,
                            getDetailLink: function(hotelId, provider, region) {
                                return bookingService.getDetailLink(hotelId, provider, region);
                            }
                        },
                        partials: {
                            hotelRating: require('rv!templates/partials/hotelRating'),
                            star: require('rv!templates/partials/star'),
                            halfStar: require('rv!templates/partials/halfStar'),
                        }
                    });

                    vacationsController.ractive.on({
                        /**
                         * Go grab differences between Travelport's data and ours
                         * @param {RactiveEvent} e 
                         */
                        onCompareClick: function(e) {
                            e.original.preventDefault();
                            var url = '/api/booking/audit/?vacationDestinationId={0}'.format(grid.utilities.selectedItem.vacDestId);
                            this.set('loadingTpDiffs', true);
                            $.get(url).then(function(diffs) {
                                this.set('tpDiffs', diffs.length === 0 ? ['No differences'] : diffs);
                                this.set('loadingTpDiffs', false);
                            }.bind(this), function(err) {
                                this.set('tpDiffs', ['An error occurred while checking diffs']);
                                this.set('loadingTpDiffs', false);
                            }.bind(this));
                        }
                    });
                    layout.loadServerData();
                };

                grid.pkColumnName = "VacationID";
                grid.init($("#tbl_Vacations"), columns, ajaxURL);
                grid.databind();
                grid.onDataBound = function() {
                    HandleEditVacationName();
                    var hasVacations = grid.currentDataSource.length > 0;
                    if (!hasVacations) {
                        grid.$table.hide();
                        $("#NoVacations").show();
                    }
                };

                var vacationId = utils.querystring('v', qs);
                grid.loadItem(vacationId, 'selecting');

                /*******/

                /*Edit Vacation Name*/
                function HandleEditVacationName() {
                    $("i[data-vacationId]").off("click").on("click", function() {
                        var $this = $(this),
                            $name = $this.prev(),
                            currentName = $name.text(),
                            vacId = $this.attr("data-vacationId"),
                            template = '<span class="editNameContainer">' +
                                '<input type="text" value="{0}" /><br />' +
                                '<button type="button" class="btn btn-primary btn-small">Save</button>' +
                                '<button type="button" class="btn btn-small cancelNameChange">Cancel</button>' +
                                '<div class="alert" style="display:none;"></div>' +
                                '</span>';

                        var editNameContainer = $(this).parent().hide().after(template.format(currentName)).next();

                        //set up handlers
                        $(".btn-primary", editNameContainer).off("click").on("click", function() {
                            var $this = $(this),
                                newName = $("input[type='text']", editNameContainer).val(),
                                errorMsg = $(".alert", editNameContainer);

                            if (newName.length < 50) {
                                $this.prop('disabled', true);

                                $.post(ajaxURL, { method: "EditVacationName", vacId: vacId, Name: newName }, function(response) {
                                    Utilities.handleAJAXResponse(response, function(obj) {
                                            $name.text(newName);
                                            revertToDisplayView(editNameContainer);
                                        },
                                        function(error) {
                                            Utilities.setError(error, errorMsg);
                                        });
                                }).complete(function() {
                                    $this.prop('disabled', false);
                                });
                            } else {
                                Utilities.setError("Please enter a shorter name.", errorMsg);
                            }
                        });

                        $(".cancelNameChange").off("click").on("click", function() {
                            $(this).parent().prev().show().end().remove();
                        });

                        Utilities.setDefaultButton(editNameContainer, $(".btn-primary", editNameContainer));
                        $("input[type='text']", editNameContainer).focus();
                    });
                }

                function revertToDisplayView($editContainer) {
                    $editContainer.prev().show().end().remove();
                }
                /*****/
            }

            return layout.initStatic('/fe/templates/member/vacations').then(init);
        },

        unload: function () {
            var editNameContainers = $('.editNameContainer');
            window.Utilities.unSetDefaultButton(editNameContainers);
            $('.cancelNameChange').off('click');
            $('.btn-primary', editNameContainers).off('click');
            $('i[data-vacationId]').off('click');
            $('#refreshPlan').off('click');
            $('#vac_tabs a').off('click');
            if (vacationsController.ractive != null) {
                vacationsController.ractive.teardown();
            }
            if (vacationsController.bookController != null) {
                vacationsController.bookController.unload();
            }
            vacationsController.grid.unload();
        }
    };
    return vacationsController;
});
